module.exports = __webpack_public_path__ + "img/Video interview Icon - white.288dc3cc.svg";